import create from "./create.json";
import edit from "./edit.json";

export default {
  create,
  edit,
};
